import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { CourseFilterService } from '../_services/course-filter.service';
import { Course } from 'lms-api';
import { CourseBundle } from 'lms-api';
import { UserCourseDataService } from 'lms-api';
import { LmsUserService } from 'lms-api';

@Component({
  selector: 'app-bundle-view',
  templateUrl: './bundle-view.component.html',
  styleUrls: ['./bundle-view.component.scss']
})
export class BundleViewComponent implements OnInit {
  public bundle: CourseBundle;
  public courses: Course[];

  constructor(
    private ucdService: UserCourseDataService,
    public lmsUserService: LmsUserService,
    public courseFilterService: CourseFilterService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.ucdService.Bundles$.subscribe(bundles => {
        if (bundles) {
          this.bundle = bundles.find(bundle => bundle.alias == params.get('alias'));
          if (this.bundle) {
            this.courses = [...this.bundle.courses];
          }
        }
      });
    }
    );

  }

}
